export const setLoading = (state, payload) => {
  state.loading = payload;
};

export const setError = (state, payload) => {
  state.error = payload;
};

export const setUsuario = (state, payload) => {
  state.usuario = payload;
};

export const setUsuarioGestao = (state, payload) => {
  state.usuarioGestao = payload;
};

export const setCaptcha = (state, payload) => {
  state.captcha = payload;
};

export const setWsAtivo = (state, payload) => {
  state.wsAtivo = payload;
};
